module.exports = __webpack_public_path__ + "static/img/usBottom4.de7eb52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/usBottom4.png
// module id = RwUE
// module chunks = 2